import { Route, Routes } from 'react-router-dom';

import { mapObject } from '@client/toolkit';
import { PermissionProtectedRoute } from '../../components/permission-protected-route';
import { PermissionKeys } from '@client/api';

import { CompanyCreateRoute } from './company-create';
import { CompanyListRoute } from './company-list';
import { CompanyRoute } from './company/company.route';
import { CompaniesLayout } from './companies-layout';
import { CompanyProfileTab } from './company/tabs/company-profile.tab';
import { CompanyAgreementsTab } from './company/tabs/company-agreements.tab';
import { CompanyUsersTab } from './company/tabs/company-users.tab';
import { CompanyContactPersonsTab } from './company/tabs/company-contact-persons.tab';
import { CompanyInvoicesTab } from './company/tabs/company-invoices.tab';

export const CompaniesPaths = {
  Companies: '/companies',
  Owners: '/companies/owners',
  Managers: '/companies/managers',
  Tenants: '/companies/tenants',
  CompanyCreate: '/companies/create',
  Company: '/companies/details/:id',
  CompanyAgreements: '/companies/details/:id/agreements',
  CompanyUsers: '/companies/details/:id/users',
  CompanyContactPersons: '/companies/details/:id/contact-persons',
  CompanyInvoices: '/companies/details/:id/invoices',
};

const RouterPaths = mapObject(CompaniesPaths, (val: string) => val.replace(CompaniesPaths.Companies, ''));

export const CompaniesRouter = () => (
  <Routes>
    <Route
      element={
        <PermissionProtectedRoute requiredPermission={[PermissionKeys.Tenant.CompaniesList]}>
          <CompaniesLayout />
        </PermissionProtectedRoute>
      }
    >
      <Route index element={<CompanyListRoute />} />
      <Route path={RouterPaths.Owners} element={<CompanyListRoute role="Owner" />} />
      <Route path={RouterPaths.Managers} element={<CompanyListRoute role="Manager" />} />
      <Route path={RouterPaths.Tenants} element={<CompanyListRoute role="Tenant" />} />
      <Route path={RouterPaths.CompanyCreate} element={<CompanyCreateRoute />} />
    </Route>
    <Route path={RouterPaths.Company} element={<CompanyRoute />}>
      <Route index element={<CompanyProfileTab />} />
      <Route path="agreements" element={<CompanyAgreementsTab />} />
      <Route
        path="users"
        element={
          <PermissionProtectedRoute requiredPermission={[PermissionKeys.Tenant.CompanyUsersList]}>
            <CompanyUsersTab />
          </PermissionProtectedRoute>
        }
      />
      <Route path="contact-persons" element={<CompanyContactPersonsTab />} />
      <Route path="invoices" element={<CompanyInvoicesTab />} />
    </Route>
  </Routes>
);
